import { LocationIntegrationStatus } from '@constants/companies';
import { LocationIntegrationName, ProfileName } from '@constants/integrations';
import { normalizeSearchText } from '@helpers/search';

// Shared shape for location autocomplete/select options: { id, label, group }.
// `noneGroup` is the (already translated) group label for locations with no brand.
export const toLocationOption = (location, noneGroup) => ({
    id: location.companyId,
    label: location.internalName,
    group: location.brand ? location.brand.title : noneGroup,
});

// Keep in sync with UrlPattern in server LocationDescriptionValidator — deliberately ASCII and
// case-sensitive on bare domains so JS and .NET match identically.
const DESCRIPTION_URL_PATTERN =
    /(?:[Hh][Tt][Tt][Pp][Ss]?:\/\/|[Ww][Ww][Ww]\.)\S+|(?<![A-Za-z0-9_@-])[A-Za-z0-9-]+\.(?:com|net|org|io|info|biz|shop|store|online|site|app|dev|ai|xyz|club)(?![A-Za-z0-9_])/;

export const descriptionContainsUrl = text => !!text && DESCRIPTION_URL_PATTERN.test(text);

export const isGoogleListingConnected = location =>
    (location?.integrations ?? []).some(
        item => item.type === LocationIntegrationName.Google && item.status !== LocationIntegrationStatus.Disconnected,
    );

export const isPinFollowingGoogle = location =>
    isGoogleListingConnected(location) &&
    (location?.profiles ?? []).some(p => p.type === ProfileName.GoogleOfficial && p.syncEnabled && p.listingHasPin) &&
    !!location?.latitude &&
    !!location?.longitude;

export const resolveRegionName = (countryEntry, region) => {
    const folded = normalizeSearchText(region);
    if (!folded) return '';
    const states = countryEntry?.states ?? [];
    const match =
        states.find(item => item.name === region) ||
        states.find(item => normalizeSearchText(item.state_code) === folded) ||
        states.find(item => normalizeSearchText(item.name) === folded);
    return match?.name ?? region;
};
